import { useContext } from 'react';
import { CarouselAPIContext } from '../CarouselAPIContext';

export const useCarouselApi = () => {
  const carouselAPI = useContext(CarouselAPIContext);

  if (!carouselAPI) {
    throw new Error(
      'The hook useCarouselAPI should be used only inside ' +
        'the carousel element.'
    );
  }

  return carouselAPI;
};
